if (typeof boostPFSThemeConfig !== "undefined") {
  // Override Settings

  let productsPerPage = boostPFSConfig.custom.products_per_page;
  if (window.collectionPromos) {
    let division =
      productsPerPage % JSON.parse(window.collectionPromos.position).length;
    if (division != 0) {
      productsPerPage = productsPerPage + 2;
    }
  }

  var boostPFSFilterConfig = {
    general: {
      limit: productsPerPage,
      loadProductFirst: false,
      numberFilterTree: 2,
      selectOptionContainer: ".grid__item .card-wrapper",
      stickyFixTopPos: false,
      paginationType: "load_more",
      filterTreeMobileStyle: "style3",
      showRefineBy: true,
    },
    selector: {
      otpTopCartCount: ".cart-count-bubble",
    },
  };
}
// Fix the confict suggestion search in Debut theme
if (typeof theme !== "undefined" && theme.hasOwnProperty("settings"))
  theme.settings.predictiveSearchEnabled = false;

(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];

  BoostPFS.inject(this);

  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data["variants"][0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item

  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : "";
    var saleClass = onSale ? boostPFSTemplate.saleClass : "";

    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add Card product class
    itemHtml = itemHtml.replace(
      /{{cardProductClass}}/g,
      buildCardProductClass()
    );
    // Add sold out Label
    itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
    // Add sale Label
    itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
    // Add Variant Info
    itemHtml = itemHtml.replace(/{{itemVariants}}/g, buildVariants(data));
    itemHtml = itemHtml.replace(/{{itemSwatches}}/g, buildSwatches(data));
    // Add Wishlist
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, buildWishlistButton(data));
    // Add Badges
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

    itemHtml = itemHtml.replace(
      /{{itemPromo}}/g,
      buildPromos(data, this.index)
    );

    itemHtml = itemHtml.replace(/{{itemReview}}/g, buildReviews(data));

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(
      /{{itemTitle}}/g,
      data.title.replace(" by Lords & Labradors", "")
    );
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrlWithVariant(data)
    );
    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildImages(data) {
    var html = "",
      aspectRatio = "",
      rangeWidths = boostPFSRangeWidths,
      paddingBottom = 100;

    var dataSrcSet = "",
      imgAlt = data.title,
      flipImageSrcSet = "";

    var activeSwapImage =
      !Utils.isMobile() &&
      images.length > 1 &&
      boostPFSThemeConfig.custom.hasOwnProperty("show_secondary_image") &&
      boostPFSThemeConfig.custom.show_secondary_image == true;

    for (var i = 0; i < rangeWidths.length; i++) {
      dataSrcSet +=
        Utils.getFeaturedImage(images, rangeWidths[i] + "x") +
        " " +
        rangeWidths[i] +
        "w";

      if (activeSwapImage) {
        flipImageSrcSet +=
          Utils.optimizeImage(images[1]["src"], rangeWidths[i] + "x") +
          " " +
          rangeWidths[i] +
          "w";
      }

      if (i < rangeWidths.length - 1) {
        dataSrcSet += ", ";

        if (activeSwapImage) {
          flipImageSrcSet += ", ";
        }
      }
    }

    if (images.length > 0) {
      aspectRatio = images[0]["width"] / images[0]["height"];
      paddingBottom = (1 / aspectRatio) * 100;

      html += "<div";
      if (
        boostPFSThemeConfig.custom.hasOwnProperty("add_image_padding") &&
        boostPFSThemeConfig.custom.add_image_padding === true
      ) {
        html += ' class="card__media-full-spacer"';
      }
      html += ">";
      html += '<div class="media media--transparent media--';
      if (boostPFSThemeConfig.custom.hasOwnProperty("media_size")) {
        html += boostPFSThemeConfig.custom.media_size;
      }
      html += ' media--hover-effect"';
      if (
        boostPFSThemeConfig.custom.hasOwnProperty("media_size") &&
        boostPFSThemeConfig.custom.media_size == "adapt" &&
        images.length > 0
      ) {
        html += ' style="padding-bottom: ' + paddingBottom + '%"';
      }
      html += ">";
      html +=
        '<img class="motion-reduce"' +
        'loading="lazy"' +
        'srcset="' +
        dataSrcSet +
        '" ' +
        'height="' +
        images[0].height +
        '" ' +
        'width="' +
        images[0].width +
        '" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
        'src="' +
        Utils.optimizeImage(images[0].src, "533x") +
        '" ' +
        'alt="' +
        imgAlt +
        '" />';

      if (activeSwapImage) {
        html +=
          '<img class="motion-reduce"' +
          'loading="lazy"' +
          'srcset="' +
          flipImageSrcSet +
          '" ' +
          'height="' +
          images[1].height +
          '" ' +
          'width="' +
          images[1].width +
          '" ' +
          'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
          'src="' +
          Utils.optimizeImage(images[1].src, "533x") +
          '" ' +
          'alt="' +
          imgAlt +
          '" />';
      }
      html += "</div>";
      html += "</div>";
    } else {
      html +=
        '<div class="card__content"><h2 class="card__text h2">' +
        data.title +
        "</h2></div>";
    }
    return html;
  }

  function buildCardProductClass() {
    var html = "";
    if (!images || (images && images.length === 0)) {
      html = "card--text-only card--soft";
    } else if (
      boostPFSThemeConfig.custom.hasOwnProperty("show_image_outline") &&
      boostPFSThemeConfig.custom.show_image_outline
    ) {
      html = "card--outline";
    }
    return html;
  }

  function buildVendor(data) {
    var html = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("show_vendor") &&
      boostPFSThemeConfig.custom.show_vendor === true
    ) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }

  function buildPrice(data) {
    var html = "";
    var noComparePrice =
      data.price_varies === false && data.compare_at_price_varies;
    var moneyPrice = priceVaries
      ? boostPFSConfig.label.from_price_html.replace(
          /{{ price }}/,
          Utils.formatMoney(data.price_min)
        )
      : Utils.formatMoney(data.price_min);
    var unitPriceClass =
      !data.available ||
      typeof data?.selected_or_first_available_variant
        ?.unit_price_measurement === "undefined"
        ? "hidden"
        : "";
    html = `<div class="price ${soldOut ? "price--sold-out" : ""} ${
      onSale ? "price--on-sale" : ""
    }${noComparePrice ? "price--no-compare" : ""}">
					<div class="price__container">
						<div class="price__regular">
							<div>
								<span class="visually-hidden visually-hidden--inline">
									${boostPFSConfig.label.regular_price}
								</span>
							</div>
							<div>
								<span class="price-item price-item--regular">
									${moneyPrice}
						  		</span>
							</div>
						</div>
						<div class="price__sale">
							<div class="price__compare">
								<span class="visually-hidden visually-hidden--inline">
									${Utils.formatMoney(data.sale_price)}
								</span>
							</div>
							<div class="price__compare">
								<s class="price-item price-item--regular">
								${Utils.formatMoney(data.compare_at_price_min)}
								</s>
						  	</div>
							<div>
							  <span class="visually-hidden visually-hidden--inline">${
                  boostPFSConfig.label.sale_price
                }</span>
							</div>
							<div class="price__last">
								<span class="price-item price-item--sale">
									${moneyPrice}
								</span>
						  	</div>
						</div>
						<small class="unit-price caption ${unitPriceClass}">
							<div class="visually-hidden">${boostPFSConfig.label.unit_price}</div>
							<div class="price__last">
								<span>${Utils.formatMoney(
                  data.selected_or_first_available_variant &&
                    data.selected_or_first_available_variant.unit_price
                )}</span>
								<span aria-hidden="true">/</span>
								<span class="visually-hidden">&nbsp;${
                  boostPFSConfig.label.unit_price_separator
                }&nbsp;</span>
							</div>
					  </small>
					</div>
				</div>`;
    return html;
  }

  function buildSoldOutLabel() {
    // Build Sold out label
    var soldOutLabel = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty(
        "sold_out_badge_color_scheme"
      ) &&
      soldOut
    ) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(
        /{{soldOutBadgeClass}}/g,
        boostPFSThemeConfig.custom.sold_out_badge_color_scheme
      );
    }
    return soldOutLabel;
  }

  function buildVariants(data) {
    var variantInfo = "";
    let optionName;
    let divider;
    const fakeVariants = data.metafields.find(
      (metafield) =>
        metafield.namespace === "fake_variants" && metafield.key == "products"
    );
    const fakeVariantsCount = fakeVariants
      ? fakeVariants.value.split("|").length
      : 0;

    variantInfo = '<div class="card__variants">';
    if (data.variants.length >= 1) {
      data.options_with_values.forEach((option, index) => {
        let optionCount = option.values.length;
        if (option.label === "Colour" || option.label === "Color")
          optionCount = option.values.length + fakeVariantsCount;
        if (option.values.length > 1) {
          optionName = option.label + "s";
        } else {
          optionName = option.label;
        }
        if (
          optionName != "Title" &&
          optionName != "Personalisations" &&
          optionName != "Personalised" &&
          optionName != "Personaliseds"
        ) {
          if (index == 0) {
            divider = "<span>+</span>";
          } else {
            divider = "<span>|</span>";
          }
          variantInfo += `${divider} ${optionCount} ${optionName}`;
        }
      });
    }
    variantInfo += "</div>";
    return variantInfo;
  }

  function buildSwatches(data) {
    let swatches = "";
    let limit = 4;
    let variantCount = 0;

    const productHandle = data.handle;
    const fake_variants = data.metafields.find(
      (metafield) =>
        metafield.namespace === "fake_variants" && metafield.key == "products"
    );

    data.variants.some((variant) => {
      if (
        (variant.option_colour && data.variants.length >= 1) ||
        (variant.option_color && data.variants.length >= 1)
      ) {
        if (variant.option_colour) {
          limit--;
          variantCount++;
        }
        swatches += `<div class="js-card-real-swatch card__swatches" data-handle="${productHandle}"></div>`;
        return true;
      }
    });

    if (fake_variants) {
      let variantHandles = fake_variants.value.split("|");
      variantCount += variantHandles.length;
      variantHandles.push(productHandle);

      variantHandles.slice(0, limit).forEach((handle) => {
        if (handle != productHandle) {
          swatches += `<a href="/products/${handle}" class="js-card-swatch product__swatch--collection" data-handle="${handle}"></a>`;
        }
      });
    }

    if (variantCount > limit) {
      swatches += `<a href="/products/${productHandle}" class="product__swatch--plus"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></svg></a>`;
    }

    return swatches;
  }

  function buildLabels(data) {
    // Build Three For Two Label
    var threeForTwoLabel = "";
    if (
      data.tags.includes("ThreeForTwo") ||
      data.tags.includes("threefortwo")
    ) {
      threeForTwoLabel = boostPFSTemplate.threeForTwoHtml.replace(
        /{{style}}/g,
        ""
      );
    }

    // Build Personalised Label
    var personalisedLabel = "";
    if (
      data.tags.includes("personalised") ||
      data.tags.includes("Personalised")
    ) {
      personalisedLabel = boostPFSTemplate.personalisedHtml.replace(
        /{{style}}/g,
        ""
      );
    }

    // Build Pre-Order Label
    var preorderLabel = "";
    if (data.tags.includes("preorder") || data.tags.includes("Preorder")) {
      preorderLabel = boostPFSTemplate.preorderHtml.replace(/{{style}}/g, "");
    }

    // Build Sold Out Label
    var soldOutLabel = "";
    if (soldOut) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(
        /{{style}}/g,
        ""
      );
    }
    // Build Sale Label
    var saleLabel = "";
    var salePercent = "";

    if (onSale && !soldOut) {
      salePercent = Math.round(
        ((data.compare_at_price_min - data.price_min) * 100) /
          data.compare_at_price_min
      );
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, "");
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(
        /percentage/g,
        +salePercent
      );
    }

    // Build Subscription Label
    var subscribeAndSaveLabel = "";
    if (data.tags.includes("Subscribe") || data.tags.includes("subscribe")) {
      subscribeAndSaveLabel =
        boostPFSTemplate.subscribeAndSaveLabelHtml.replace(/{{style}}/g, "");
    }

    // Build New Label
    var newLabel = "";
    var secondsPerDay = 86400;
    if (boostPFSThemeConfig.custom.hasOwnProperty("new_badge_limit")) {
      var newLimit = boostPFSThemeConfig.custom.new_badge_limit * secondsPerDay;
    }
    var nowDate = new Date().getTime() / 1000;
    var publishedDate = new Date(data.published_at).getTime() / 1000;
    var dateDifference = nowDate - publishedDate;
    if (dateDifference < newLimit) {
      var newBadge = true;
    }

    if (newBadge && !soldOut && !onSale) {
      newLabel = boostPFSTemplate.newLabelHtml.replace(/{{style}}/g, "");
    }

    // Build Labels
    return (
      soldOutLabel +
      saleLabel +
      newLabel +
      threeForTwoLabel +
      preorderLabel +
      personalisedLabel +
      subscribeAndSaveLabel
    );
  }

  function buildPromos(data, itemIndex) {
    // Build Sold out label

    var itemPromo = "";

    itemIndex = itemIndex + 1;

    if (window.collectionPromos) {
      var positions = JSON.parse(window.collectionPromos.position);
      var title = JSON.parse(window.collectionPromos.title);
      var content = JSON.parse(window.collectionPromos.content);
      var buttonLabel = JSON.parse(window.collectionPromos.button_label);
      var buttonURL = JSON.parse(window.collectionPromos.button_url);
      var image = JSON.parse(window.collectionPromos.image);

      positions.forEach((position, index) => {
        if (position == itemIndex && image != null) {
          itemPromo = `<div class="grid__item collection-content">
					<div>
						<img src='${image[index][0].cloudinary_src}'>
					</div>
					<div>
						<h4>${title[index]}</h4>
						<p>${content[index]}</p>
						<a href="${buttonURL[index]}" class="button">${buttonLabel[index]}</a>
					</div>
					</div>`;
        }
      });
    }
    // Build Labels
    return itemPromo;
  }

  function buildReviews(data) {
    if (window.trustpilot.collection) {
      var itemReviewHtml =
        '<div class="trustpilot-widget" data-locale="en-GB" data-template-id="577258fb31f02306e4e3aaf9" data-businessunit-id="' +
        window.trustpilot.id +
        '" data-style-height="20px" data-style-width="100%" data-theme="light" data-sku="' +
        data.variants[0].sku +
        '" data-star-color="#003459" data-font-family="Lato" data-text-color="#121212" data-no-reviews="hide" data-scroll-to-list="false" data-style-alignment="left"><a href="https://uk.trustpilot.com/review/" target="_blank" rel="noopener"></a></div>';
    } else {
      var itemReviewHtml = "";
    }
    return itemReviewHtml;
  }

  function buildWishlistButton(data) {
    var itemWishlistHtml =
      '<button data-with-epi="true" class="card__wishlist swym-button swym-add-to-wishlist-view-product js-wishlist-button product_' +
      data.id +
      '" data-swaction="addToWishlist" data-product-id="' +
      JSON.stringify(data.id) +
      '" data-variant-id="' +
      data.variants[0].id +
      '" data-product-url="' +
      boostPFSConfig.shop.url +
      Utils.buildProductItemUrl(data, false) +
      '"></button>';
    return itemWishlistHtml;
  }

  function buildSaleLabel() {
    // Build Sale label
    var saleLabel = "";

    if (onSale && !soldOut) {
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/'-percentage-'/g, 20);
    }

    return saleLabel;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return "";
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml =
      currentPage > 1 ? boostPFSTemplate.previousActiveHtml : "";
    previousHtml = previousHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage - 1)
    );
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml =
      currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : "";
    nextHtml = nextHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage + 1)
    );
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (
      var iBefore = currentPage - 1;
      iBefore > currentPage - 3 && iBefore > 0;
      iBefore--
    ) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift("...");
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (
      var iAfter = currentPage + 1;
      iAfter < currentPage + 3 && iAfter <= totalPage;
      iAfter++
    ) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push("...");
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = "";
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == "...") {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml +=
          pageArr[iPage] == currentPage
            ? boostPFSTemplate.pageItemSelectedHtml
            : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
      );
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || "";
        // Build content
        var sortingItemsHtml = "";
        for (var k in sortingArr) {
          var isSelected = "";
          if (paramSort == k) {
            isSelected = 'selected="selected"';
          }
          sortingItemsHtml +=
            '<option value="' +
            k +
            '"' +
            isSelected +
            ">" +
            sortingArr[k] +
            "</option>";
        }
        html = boostPFSTemplate.sortingHtml.replace(
          /{{sortingItems}}/g,
          sortingItemsHtml
        );
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (
      jQ(".boost-pfs-filter-custom-sorting").hasClass(
        "boost-pfs-filter-sort-active"
      )
    ) {
      jQ(".boost-pfs-filter-custom-sorting").toggleClass(
        "boost-pfs-filter-sort-active"
      );
    }

    var labelSort = "";
    var paramSort = Globals.queryParams.sort || "";
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting;
    }

    jQ(".boost-pfs-filter-custom-sorting button span span").text(labelSort);
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    jQ(Selector.topSorting + " .facet-filters__sort").change(function (e) {
      e.preventDefault();

      // Initially show 'Sort' when sorting order is selcted, change 'Sort' to selected option label with icon-caret.
      let selectedIndex = e.target.options.selectedIndex;
      jQ("#js-facet-sort").html(
        e.target.options[selectedIndex].label +
          `<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
		</svg>`
      );

      FilterApi.setParam("sort", jQ(this).val());
      FilterApi.setParam("page", 1);
      FilterApi.applyFilter("sort");
    });
  };

  ProductList.prototype.bindEvents = function (data, event) {
    if (!data) data = this.data;
    let productEls = document.querySelectorAll(".card-information a");

    if (productEls.length > 0) {
      productEls.forEach((el, i) => {
        el.addEventListener("click", (e) => {
          var dataLayerObject = {
            event: "select_item",
            ecommerce: {
              items: [
                {
                  item_id: el.getAttribute("data-dl-id"),
                  item_name: el.getAttribute("data-dl-title"),
                  currency: el.getAttribute("data-dl-currency"),
                  item_brand: el.getAttribute("data-dl-brand"),
                  price: el.getAttribute("data-dl-price"),
                  discount: el.getAttribute("data-dl-discount"),
                  quantity: 1,
                  item_category: el.getAttribute("data-dl-category"),
                  item_list_id: el.getAttribute("data-dl-list-id"),
                  item_list_name: el.getAttribute("data-dl-list-name"),
                  index: i,
                },
              ],
            },
          };
          updateDataLayer(dataLayerObject);
        });
      });
    }
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;

    jQ(".card-information a").attr(
      "data-dl-currency",
      window.boostStrings.currency
    );
    jQ(".card-information a").attr(
      "data-dl-list-id",
      window.boostStrings.collectionId
    );
    jQ(".card-information a").attr(
      "data-dl-list-name",
      window.boostStrings.collectionName
    );

    let productEls = document.querySelectorAll(".card-information a");

    if (productEls.length > 0) {
      productEls.forEach((el) => {
        let dataProductPrice = el.getAttribute("data-dl-price");
        let dataProductDiscount = el.getAttribute("data-dl-discount");

        if (dataProductPrice !== null) {
          el.setAttribute("data-dl-price", dataProductPrice.replace("£", ""));
        }

        if (
          dataProductDiscount !== null &&
          dataProductDiscount.includes("£0")
        ) {
          el.setAttribute("data-dl-discount", 0);
        }

        if (
          dataProductDiscount !== null &&
          !dataProductDiscount.includes("£0")
        ) {
          let dataProductDiscountSplit = dataProductDiscount
            .replaceAll("£", "")
            .split("-");

          if (dataProductDiscountSplit.length > 0) {
            el.setAttribute(
              "data-dl-discount",
              (
                dataProductDiscountSplit[0] - dataProductDiscountSplit[1]
              ).toFixed(2)
            );
          }
        }
      });
    }

    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    document.dispatchEvent(new CustomEvent("load-swatches"));
    document.dispatchEvent(new CustomEvent("trustpilot:collections-loaded"));
    document.dispatchEvent(
      new CustomEvent("reload-trustpilot", {
        detail: { parent: document },
      })
    );
  };

  // Build Additional Elements
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    jQ(".boost-pfs-filter-total-product").html(
      "<span>" +
        data.products.length +
        "</span> of " +
        data.total_product +
        " Items"
    );
    jQ(
      ".boost-pfs-filter-refine-by-wrapper .boost-pfs-filter-option-title-heading"
    ).html("<span>" + data.total_product + " Items");
    jQ(this.filterTrees[0].selector.applyAllButtonContainer).prepend(
      this.filterTrees[0].clearAllButton.$element
    );

    let buildActiveFiltersNumber = () => {
      let activeFilters = document.querySelectorAll(
        ".boost-pfs-filter-selected-items-mobile"
      );
      let activeFilterCount = 0;
      let refineFilter = document.querySelector(
        ".boost-pfs-filter-tree-mobile-button-label"
      );

      activeFilters.forEach((el) => {
        if (el.textContent != "") {
          let filtersSplit = el.textContent.split(",");

          filtersSplit.forEach((ele) => {
            activeFilterCount++;
          });
        }
      });

      if (activeFilterCount == 0) {
        refineFilter.innerHTML = window.collectionStrings.filterBy.replace(
          "<span></span>",
          "<span></span>"
        );
      } else {
        refineFilter.innerHTML = window.collectionStrings.filterBy.replace(
          "<span></span>",
          '<span class="pfs-filter-count">' + activeFilterCount + "</span>"
        );
      }
    };

    buildActiveFiltersNumber();
  };

  /************************** END BUILD TOOLBAR **************************/
})();
